import React, { useState, useEffect, useRef } from "react";
import "./Apointment.css";
import { Modal } from "react-responsive-modal";
import LpForm from "../../packageDetailsPage/LpForm";
import { useDispatch, useSelector } from "react-redux";
import { getCall, getCities } from "../../../Redux/Actions";
import { GET_CALL_RESET } from "../../../Redux/Constants";
import { BrowserRouter as Router, Switch, useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import CommonForm from "../../../components/Form/CommonForm";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Apointment({ img, parentPath, butname }) {
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const scrollTop = () => {
    window.scroll(0, 0);
  };

  return (
    <div className="Apointment">
      <div className="Apointment__content">
        <div className="fiveStar">
          <LazyLoadImage src={img} alt={img} delayTime="100" />
        </div>
        <h3>Get the best Health Packages in India</h3>
        <span
          //    onClick={scrollTop}
          onClick={parentPath === "lpPage" ? scrollTop : onOpenModal}
          id="makeAppointment"
        >
          {butname ? butname : "Book Test Now"}
        </span>
        <Modal open={open} onClose={onCloseModal} center>
          <LpForm
            position={"appointment"}
            butname={"SUBMIT"}
            title={"Make an Appointment"}
            autoFill={true}
          />
        </Modal>
      </div>
    </div>
  );
}

export default Apointment;
